
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns154673888187cb756ce812eafd3c99baen from './en.yaml'
            i18n.addResourceBundle('en', '154673888187cb756ce812eafd3c99ba', flattenObject(ns154673888187cb756ce812eafd3c99baen), true, true);
        
        export default '154673888187cb756ce812eafd3c99ba';
    